import { type ComponentType } from 'react';

import { type NewCoreIconProps } from '@atlaskit/icon';
import GoalIcon from '@atlaskit/icon/core/goal';
import BlogIcon from '@atlaskit/icon/core/page';
import WorkItemIcon from '@atlaskit/icon/core/work-item';
import { Ati } from '@atlassian/ari';

import type { CrossAppMenuItem, ItemResponse } from '../../types';

async function loadIcon(iconName: string): Promise<ComponentType<NewCoreIconProps> | undefined> {
	try {
		if (!iconName) {
			return undefined;
		}

		if (iconName === '__mock-icon--work-item') {
			return WorkItemIcon;
		}
		if (iconName === '__mock-icon--page') {
			return BlogIcon;
		}

		if (iconName === '__mock-icon--goals') {
			return GoalIcon;
		}

		const iconModule = await import(`@atlaskit/icon/core/${iconName}`);
		return iconModule.default as ComponentType<NewCoreIconProps>;
	} catch (error) {
		console.error(`Failed to load icon: ${iconName}`, error);
		return undefined;
	}
}

export async function transformItems(items: ItemResponse[]): Promise<CrossAppMenuItem[]> {
	return await Promise.all(
		items.map(async (responseItem) => {
			const Icon = responseItem.icon ? await loadIcon(responseItem.icon) : undefined;
			const itemBase = {
				ati: Ati.parse(responseItem.ati),
				children: responseItem.name,
				elemBefore: Icon,
				testId: `remote-item-${responseItem.ati}`,
				product: responseItem.product,
				...(responseItem.href && { href: responseItem.href }),
			};
			if (responseItem.type === 'integration') {
				const integrationItem: CrossAppMenuItem = {
					...itemBase,
					type: responseItem.type,
					actionType: responseItem.actionType,
				};
				return integrationItem;
			} else {
				const item: CrossAppMenuItem = {
					...itemBase,
					type: responseItem.type,
				};
				return item;
			}
		}),
	);
}
